var map = {
	"./": [
		21384,
		1384
	],
	"./AlertIcon": [
		93280,
		3280
	],
	"./AlertIcon.tsx": [
		93280,
		3280
	],
	"./ArrowLeftIcon": [
		88508,
		8508
	],
	"./ArrowLeftIcon.tsx": [
		88508,
		8508
	],
	"./ArrowRightLongIcon": [
		25684,
		5684
	],
	"./ArrowRightLongIcon.tsx": [
		25684,
		5684
	],
	"./BonusFillIcon": [
		35015,
		5015
	],
	"./BonusFillIcon.tsx": [
		35015,
		5015
	],
	"./BonusIcon": [
		21969,
		1969
	],
	"./BonusIcon.tsx": [
		21969,
		1969
	],
	"./CallIcon": [
		2001,
		2001
	],
	"./CallIcon.tsx": [
		2001,
		2001
	],
	"./CameraIcon": [
		19430,
		9430
	],
	"./CameraIcon.tsx": [
		19430,
		9430
	],
	"./CapIcon": [
		37559,
		7559
	],
	"./CapIcon.tsx": [
		37559,
		7559
	],
	"./CartIcon": [
		28714,
		8714
	],
	"./CartIcon.tsx": [
		28714,
		8714
	],
	"./CartWhiteIcon": [
		76932,
		6932
	],
	"./CartWhiteIcon.tsx": [
		76932,
		6932
	],
	"./ChatboxIcon": [
		6349,
		6349
	],
	"./ChatboxIcon.tsx": [
		6349,
		6349
	],
	"./CheckIcon": [
		40041,
		41
	],
	"./CheckIcon.tsx": [
		40041,
		41
	],
	"./ChevronBlackIcon": [
		92918,
		2918
	],
	"./ChevronBlackIcon.tsx": [
		92918,
		2918
	],
	"./ChevronIcon": [
		43425,
		3425
	],
	"./ChevronIcon.tsx": [
		43425,
		3425
	],
	"./ChevroneBottomIcon": [
		68946,
		8946
	],
	"./ChevroneBottomIcon.tsx": [
		68946,
		8946
	],
	"./ClipboardIcon": [
		74734,
		4734
	],
	"./ClipboardIcon.tsx": [
		74734,
		4734
	],
	"./CloseCircleIcon": [
		87698,
		7698
	],
	"./CloseCircleIcon.tsx": [
		87698,
		7698
	],
	"./CloseIcon": [
		45281,
		5281
	],
	"./CloseIcon.tsx": [
		45281,
		5281
	],
	"./Courier": [
		16062,
		6062
	],
	"./Courier.tsx": [
		16062,
		6062
	],
	"./CourierIcon": [
		73606,
		3606
	],
	"./CourierIcon.tsx": [
		73606,
		3606
	],
	"./DeleteIcon": [
		67605,
		7605
	],
	"./DeleteIcon.tsx": [
		67605,
		7605
	],
	"./DislikeIcon": [
		32273,
		2273
	],
	"./DislikeIcon.tsx": [
		32273,
		2273
	],
	"./EditIcon": [
		25796,
		5796
	],
	"./EditIcon.tsx": [
		25796,
		5796
	],
	"./ExitIcon": [
		31882,
		1882
	],
	"./ExitIcon.tsx": [
		31882,
		1882
	],
	"./FailedCircleIcon": [
		29650,
		9650
	],
	"./FailedCircleIcon.tsx": [
		29650,
		9650
	],
	"./Filter": [
		8278,
		8278
	],
	"./Filter.tsx": [
		8278,
		8278
	],
	"./GiftIcon": [
		64795,
		4795
	],
	"./GiftIcon.tsx": [
		64795,
		4795
	],
	"./HalalIcon": [
		56926,
		6926
	],
	"./HalalIcon.tsx": [
		56926,
		6926
	],
	"./HeartIcon": [
		2873,
		2873
	],
	"./HeartIcon.tsx": [
		2873,
		2873
	],
	"./HomeIcon": [
		83949,
		3949
	],
	"./HomeIcon.tsx": [
		83949,
		3949
	],
	"./InfoCircleIcon": [
		10094,
		94
	],
	"./InfoCircleIcon.tsx": [
		10094,
		94
	],
	"./InfoFillGreenIcon": [
		63984,
		3984
	],
	"./InfoFillGreenIcon.tsx": [
		63984,
		3984
	],
	"./InfoFillIcon": [
		20550,
		550
	],
	"./InfoFillIcon.tsx": [
		20550,
		550
	],
	"./InfoGreenIcon": [
		74387,
		4387
	],
	"./InfoGreenIcon.tsx": [
		74387,
		4387
	],
	"./LikeIcon": [
		37160,
		7160
	],
	"./LikeIcon.tsx": [
		37160,
		7160
	],
	"./LocationIcon": [
		2270,
		2270
	],
	"./LocationIcon.tsx": [
		2270,
		2270
	],
	"./Logo": [
		80124,
		124
	],
	"./Logo.tsx": [
		80124,
		124
	],
	"./MastercardIcon": [
		17391,
		7391
	],
	"./MastercardIcon.tsx": [
		17391,
		7391
	],
	"./MenuIcon": [
		50319,
		319
	],
	"./MenuIcon.tsx": [
		50319,
		319
	],
	"./MinusClearIcon": [
		41479,
		1479
	],
	"./MinusClearIcon.tsx": [
		41479,
		1479
	],
	"./MinusIcon": [
		89051,
		9051
	],
	"./MinusIcon.tsx": [
		89051,
		9051
	],
	"./NavIcon": [
		22127,
		2127
	],
	"./NavIcon.tsx": [
		22127,
		2127
	],
	"./PlusBlackIcon": [
		23125,
		3125
	],
	"./PlusBlackIcon.tsx": [
		23125,
		3125
	],
	"./PlusCircleGreenIcon": [
		1001,
		1001
	],
	"./PlusCircleGreenIcon.tsx": [
		1001,
		1001
	],
	"./PlusClearIcon": [
		89354,
		9354
	],
	"./PlusClearIcon.tsx": [
		89354,
		9354
	],
	"./PlusIcon": [
		8942,
		8942
	],
	"./PlusIcon.tsx": [
		8942,
		8942
	],
	"./QuestionCircleIcon": [
		75197,
		5197
	],
	"./QuestionCircleIcon.tsx": [
		75197,
		5197
	],
	"./SearchIcon": [
		33588,
		3588
	],
	"./SearchIcon.tsx": [
		33588,
		3588
	],
	"./SettingsIcon": [
		17433,
		7433
	],
	"./SettingsIcon.tsx": [
		17433,
		7433
	],
	"./ShareIcon": [
		5291,
		5291
	],
	"./ShareIcon.tsx": [
		5291,
		5291
	],
	"./ShareOutIcon": [
		89063,
		9063
	],
	"./ShareOutIcon.tsx": [
		89063,
		9063
	],
	"./Shop": [
		94149,
		4149
	],
	"./Shop.tsx": [
		94149,
		4149
	],
	"./StarBorderIcon": [
		58950,
		8950
	],
	"./StarBorderIcon.tsx": [
		58950,
		8950
	],
	"./StarGoldIcon": [
		42414,
		4318
	],
	"./StarGoldIcon.tsx": [
		42414,
		4318
	],
	"./StarGreenIcon": [
		29572,
		9572
	],
	"./StarGreenIcon.tsx": [
		29572,
		9572
	],
	"./StarIcon": [
		5550,
		5550
	],
	"./StarIcon.tsx": [
		5550,
		5550
	],
	"./StarTransparentIcon": [
		70412,
		412
	],
	"./StarTransparentIcon.tsx": [
		70412,
		412
	],
	"./StatusCancelled": [
		4872,
		4872
	],
	"./StatusCancelled.tsx": [
		4872,
		4872
	],
	"./StatusCurrent": [
		59231,
		9231
	],
	"./StatusCurrent.tsx": [
		59231,
		9231
	],
	"./StatusFuture": [
		56985,
		6985
	],
	"./StatusFuture.tsx": [
		56985,
		6985
	],
	"./StatusPassed": [
		87000,
		7000
	],
	"./StatusPassed.tsx": [
		87000,
		7000
	],
	"./SuccessCircleIcon": [
		96700,
		6700
	],
	"./SuccessCircleIcon.tsx": [
		96700,
		6700
	],
	"./TaxiIcon": [
		65276,
		5276
	],
	"./TaxiIcon.tsx": [
		65276,
		5276
	],
	"./index": [
		21384,
		1384
	],
	"./index.tsx": [
		21384,
		1384
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10545;
module.exports = webpackAsyncContext;